import React from 'react';
import { XIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { FrameworkStrip } from '../FrameworkStrip';
import { finalNots } from '../../data/landing';
export function FinalCTA() {
  return <section className="bg-cream" data-id="element-163" data-mp="3mrxodntv23c1">
      <div className="mx-auto max-w-3xl px-5 py-14 text-center md:py-20" data-id="element-164" data-mp="3rs3a6ndg8vm7">
        <h2 className="font-display text-[32px] font-bold leading-[1.1] text-navy sm:text-5xl" data-id="element-165" data-mp="3dt3mbhxrgkr3">
          I want you to feel prepared <em className="text-coral" data-id="element-166" data-mp="3huxj3f4u54lz">before the next meltdown happens.</em>
        </h2>

        <ul className="mx-auto mt-8 max-w-xl space-y-3 text-left" data-id="element-167" data-mp="33vfouk8rsz58">
          {finalNots.map(n => <li key={n} className="flex items-start gap-3 rounded-2xl bg-white px-4 py-3.5" data-id="element-168" data-mp="38th8b6a3z0h8">
              <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-coral" strokeWidth={3} aria-hidden="true" data-id="element-169" data-mp="1231b7xd9egum" />
              <span className="text-[17px] leading-snug text-navy" data-id="element-170" data-mp="1735prhulx1i7">{n}</span>
            </li>)}
        </ul>

        <p className="mt-8 text-lg text-muted" data-id="element-171" data-mp="q7lmnqxnd742">I've created Calm Response 5™ so you can have a simple framework ready:</p>
        <div className="mt-6" data-id="element-172" data-mp="l9aavanskmj7">
          <FrameworkStrip data-id="element-173" data-mp="z0xj88v0dlic" />
        </div>

        <p className="mx-auto mt-8 max-w-xl text-lg leading-relaxed text-muted" data-id="element-174" data-mp="yzvwv88jlclb">
          When your child becomes overwhelmed, you won't have to start from zero.
        </p>
        <p className="mt-2 font-display text-3xl font-bold text-teal-dark" data-id="element-175" data-mp="7999lu3m7d37">You'll have a place to start.</p>

        <div className="mt-10" data-id="element-176" data-mp="2bg6j9xlyz75">
          <CTAButton label="Get Calm Response 5™" microcopy="Only $27 · Instant Access · Lifetime Access · 7-Day Guarantee" data-id="element-177" data-mp="2c94pmii4gdo" />
        </div>
        <div className="mt-8" data-id="element-178" data-mp="bbcoksphszt8">
          <Countdown data-id="element-179" data-mp="bb357nyydqwi" />
        </div>
      </div>
    </section>;
}